import type { ResearchLibraryChatBackend } from "@/components/mission-control/researchLibraryChatBackends";
import type {
  FrontendChatId,
  FrontendChatMessageId,
  OrganizationId,
} from "@/utils/types";
import { queryOptions } from "@tanstack/react-query";

export const missionControlChatsOptions = <
  T extends FrontendChatId,
  U extends FrontendChatMessageId,
>(
  backend: ResearchLibraryChatBackend<T, U>,
  workspaceId: OrganizationId | undefined
) =>
  queryOptions({
    queryKey: [backend.listQueryKey, workspaceId ?? ""] as const,
    queryFn: () => (workspaceId ? backend.listChats(workspaceId) : []),
  });
